// import Swiper from "swiper/dist/js/swiper.js";
import Swiper from 'swiper/bundle';

export default class CarouselSave {
  constructor() {
    this.carousel = document.querySelectorAll(".jsCarouselSave");
    if (this.carousel) this.init();
  }

  setCarousel(i, config) {
    new Swiper(i, config);
  }

  init() {
    for (let i = 0; i < this.carousel.length; i++) {
      let config = {};

      config = {
        speed: 400,
        spaceBetween: 0,
        slidesPerView: 3,
        centeredSlides: true,
        loop: true,
        navigation: {
          nextEl: '.jsCarouselSaveNext',
          prevEl: '.jsCarouselSavePrev'
        },
        breakpoints: {
          767: {
            spaceBetween: 15
          }
        },
        pagination: {
          el: '.jsCarouselSavePagination',
          type: 'bullets',
          clickable: true,
          renderBullet: (index, className) =>
            '<span class="carousel-bullet__item ' + className + '"></span>'
        }
      };

      this.setCarousel(this.carousel[i], config);
    }
  }
}
